import Times from './Times/Times';
import Card from './Card/Card';
import Modern from './Modern/Modern';
import Parchment from './Parchment/Parchment';
import Royal from './Royal/Royal';
import Horizontal from './Horizontal/Horizontal';
import Classic from './Classic/Classic';
import Candle from './Candle/Candle';

const templates = {
  Times,
  Card,
  Modern,
  Parchment,
  Royal,
  Horizontal,
  Classic,
  Candle,
};

export default templates;